module.exports = __webpack_public_path__ + "img/ec.fc55aef1.svg";